import React, { useEffect, useMemo } from 'react';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { Link, useLocation, useNavigate, useParams, matchPath,Routes, useSearchParams, Outlet } from 'react-router-dom';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import Aside from '../../components/Aside';
import Footer from '../../components/Footer';
import getBreadcrumb from './BreadcrumbObject';

const Full = (props) => {
  const breadcrumbs = useBreadcrumbs();
  const { pathname } = useLocation();
  // A pathname feldarabolva
  const pathnameArray = pathname.split('/');
  const pathnameCheckArray = [];
  if (pathnameArray.length > 1) {
    pathnameCheckArray.push(pathnameArray.slice(pathnameArray.length - 2).join('/'));
    pathnameCheckArray.push(pathnameArray[pathnameArray.length - 2]);
  }
  if (pathnameArray.length > 2) {
    pathnameCheckArray.push([...pathnameArray.slice(pathnameArray.length - 3, pathnameArray.length - 1), 'id'].join('/'));
  }
  let lastPath = pathname.substring(pathname.lastIndexOf('/') + 1);

  const { setGlobals, globals } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const match = matchPath;
  const params = useParams;
  console.log(location);

  useEffect(()=> {
    console.log(props.route === undefined, typeof props.route)
    if (props.route === undefined) {
      setGlobals({
        ...globals,
        route: {
          navigate: navigate,
          location: location,
          match: match,
          params: params
        }
       
      })
    }
  }, [props.route])

  const { children } = props;

  return (
    <div className="app">
      <Header {...props} />
      <div className="app-body">
        <Sidebar {...props} />
        <main className="main">
          <div className="breadcrumb">
            {breadcrumbs.map(({
              breadcrumb, key
            }) => {
              const preText = breadcrumb.props.children;
              let bcText = getBreadcrumb(preText);
              if (bcText === null) {
                for (let i = 0; i < pathnameCheckArray.length; i++) {
                  bcText = getBreadcrumb(pathnameCheckArray[i]);
                  if (bcText) { break; }
                }
              }
              return bcText && bcText !== '' && (
              <div key={key}>
                <Link to={key}>{bcText}</Link>
                {preText.toLowerCase() !== lastPath && lastPath !== '' && <span className="ms-2 me-2">/</span>}
              </div>
              );
            })}
          </div>
          <div className="container-fluid">
            {console.log("PROPSPPPPS:", props)}
            {children}
            {/* <Outlet /> */}
            {/* {React.cloneElement(props.children.props.children, {...props, name:'fdfds', navigate: useNavigate(), match: matchPath, location: useLocation(), params: useParams()},  ...props.children.props.children)} */}
         
            
            {/* {console.log('children', Ro)} */}
            {/* {console.log(React.cloneElement(props.children))}
            <Ro>
              {children && children.props && children.props.children && children.props.children.map((route) => {
                React.cloneElement(route, {...props, navigate: useNavigate(), match: matchPath, location: useLocation(), params: useParams()})
              })}
            </Ro> */}
            {/* {React.cloneElement(props.children), {...props, navigate: useNavigate(), match: matchPath, location: useLocation(), params: useParams()})} */}
            
            {/* {<React.Fragment>{Ro}</React.Fragment>} */}
            {/* {props.children} */}
          </div>
        </main>
        {/* <Aside /> */}
      </div>
      <Footer />
    </div>
  );
};

export default Full;
